/**
 * OpenAPI specification metadata
 *
 * This file contains all the base metadata for the OpenAPI specification
 * that was previously stored in openapi-base.yaml.
 *
 * Note on 'as const' usage:
 * - We use 'as const' on literal values that should be treated as enums
 *   (e.g., "apiKey", "header", "3.1.0") to get precise literal types
 * - We avoid 'as const' on top-level configuration objects to prevent
 *   deep readonly types that can cause compatibility issues with libraries
 *   expecting mutable types (like zod-to-openapi)
 * - If you encounter readonly type errors, check whether the consuming
 *   library expects mutable types and remove 'as const' accordingly
 */

export const apiInfo = {
  title: "Zapier SDK API",
  version: "1.0.0",
  contact: {
    email: "engineering@zapier.com",
  },
  description: "The Zapier SDK API serves as a backend for the Zapier SDK.",
};

export const servers: Array<{ url: string; description: string }> = [];

export const tags = [
  {
    name: "Actions",
    description: "Action-related routes",
  },
  {
    name: "Apps",
    description: "App-related routes",
  },
  {
    name: "Authentications",
    description: "Authentication-related routes (deprecated, use Connections)",
  },
  {
    name: "Client Credentials",
    description: "Client credentials management routes",
  },
  {
    name: "Connections",
    description: "Connection-related routes",
  },
  {
    name: "Deduplication",
    description: "Deduplication-related routes",
  },
  {
    name: "Documentation",
    description: "Documentation-related routes",
  },
  {
    name: "Approvals",
    description: "Approval request management routes",
  },
];

/**
 * Security schemes for OpenAPI specification
 *
 * Note: 'as const' is used on enum-like literal values ("apiKey", "header")
 * to ensure TypeScript treats them as literal types rather than generic strings.
 * This provides better type safety when the OpenAPI generator validates these values.
 */
export const securitySchemes = {
  userJwt: {
    type: "apiKey" as const,
    in: "header" as const,
    name: "Authorization",
    description:
      "Format should be `JWT <your-jwt>` (you must ensure that the JWT prefix " +
      "is included in your requests).\\n\\n" +
      "Example:  `Authorization: JWT your.jwt.value.here`",
  },
} as const;

/**
 * Complete OpenAPI metadata for document generation
 */
export const openApiMetadata = {
  openapi: "3.1.0" as const,
  info: apiInfo,
  servers,
  tags,
};
